export default __webpack_public_path__ + "static/media/love-1.3c811545.svg";